import { articleTimestampFormat } from "@util/constant";
import { getFormattedTime } from "@util/helpers";

export type ArticleTimeStampProps = {
  publishedDate: string;
  updatedDate: string;
  hasUpdatedTimeDisplayed?: boolean;
};

export default function ArticleTimeStamp({
  publishedDate,
  updatedDate,
  hasUpdatedTimeDisplayed = false,
}: ArticleTimeStampProps): React.ReactElement {
  return (
    <div className="font-public-sans text-xs font-normal leading-6 text-gray-650">
      <span data-testid="article-published-time">
        Published {getFormattedTime(publishedDate, articleTimestampFormat)}
      </span>

      {hasUpdatedTimeDisplayed ? (
        <span data-testid="article-updated-time">
          {` — Updated ${getFormattedTime(updatedDate, articleTimestampFormat)}`}
        </span>
      ) : null}
    </div>
  );
}
